// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__ZYhXu","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__2-eP_"};